(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ahnenglut-horizontal-rituale"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const instances = new WeakMap();

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function getSections(root) {
      const found = [];

      if (root && root.matches && root.matches('[data-ag-horizontal]')) {
        found.push(root);
      }

      if (root && root.querySelectorAll) {
        root.querySelectorAll('[data-ag-horizontal]').forEach(function (section) {
          found.push(section);
        });
      }

      return found;
    }

    function destroySection(section) {
      const instance = instances.get(section);

      if (!instance) return;

      instance.destroy();
      instances.delete(section);
    }

    function initSection(section) {
      destroySection(section);

      const stage = section.querySelector('.ag-horizontal__stage');
      const sticky = section.querySelector('.ag-horizontal__sticky');
      const viewport = section.querySelector('.ag-horizontal__viewport');
      const track = section.querySelector('.ag-horizontal__track');

      if (!stage || !sticky || !viewport || !track) return;

      let sectionStart = 0;
      let horizontalDistance = 0;
      let frame = null;
      let resizeObserver = null;
      let destroyed = false;

      function render() {
        frame = null;

        if (destroyed) return;

        if (horizontalDistance <= 0) {
          track.style.transform = 'translate3d(0, 0, 0)';
          return;
        }

        const localScroll = window.scrollY - sectionStart;
        const x = clamp(localScroll, 0, horizontalDistance);

        track.style.transform =
          'translate3d(' + (-x) + 'px, 0, 0)';
      }

      function requestRender() {
        if (frame !== null || destroyed) return;
        frame = window.requestAnimationFrame(render);
      }

      function measure() {
        if (destroyed) return;

        track.style.transform = 'translate3d(0, 0, 0)';

        const stageRect = stage.getBoundingClientRect();

        sectionStart = window.scrollY + stageRect.top;

        horizontalDistance = Math.max(
          0,
          track.scrollWidth - viewport.clientWidth
        );

        /*
          Vertikaler Scrollweg = horizontale Strecke.
          Ein kleiner Release-Tail lässt die letzte Karte kurz stehen,
          bevor die Seite normal weiterläuft.
        */
        const releaseTail = Math.min(
          120,
          window.innerHeight * 0.1
        );

        stage.style.height =
          (window.innerHeight + horizontalDistance + releaseTail) + 'px';

        render();
      }

      function queueMeasure() {
        if (destroyed) return;

        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(measure);
        });
      }

      function onResize() {
        queueMeasure();
      }

      function onScroll() {
        requestRender();
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });

      if ('ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(function () {
          queueMeasure();
        });

        resizeObserver.observe(viewport);
        resizeObserver.observe(track);
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          if (!destroyed) queueMeasure();
        });
      }

      queueMeasure();

      window.setTimeout(function () {
        if (!destroyed) measure();
      }, 150);

      window.setTimeout(function () {
        if (!destroyed) measure();
      }, 500);

      instances.set(section, {
        measure: measure,
        destroy: function () {
          destroyed = true;

          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onResize);

          if (resizeObserver) {
            resizeObserver.disconnect();
          }

          if (frame !== null) {
            window.cancelAnimationFrame(frame);
          }
        }
      });
    }

    function initAll(root) {
      getSections(root || document).forEach(initSection);
    }

    function measureAll(root) {
      getSections(root || document).forEach(function (section) {
        const instance = instances.get(section);

        if (instance) {
          window.requestAnimationFrame(instance.measure);
        } else {
          initSection(section);
        }
      });
    }

    function boot() {
      initAll(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    window.addEventListener('load', function () {
      measureAll(document);
    }, { once: true });

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      getSections(event.target).forEach(destroySection);
    });

    document.addEventListener('shopify:section:select', function (event) {
      window.setTimeout(function () {
        measureAll(event.target);
      }, 60);
    });

    document.addEventListener('shopify:section:reorder', function (event) {
      window.setTimeout(function () {
        measureAll(document);
      }, 100);
    });

    document.addEventListener('shopify:block:select', function (event) {
      const section = event.target.closest('[data-ag-horizontal]');

      if (!section) return;

      window.setTimeout(function () {
        const instance = instances.get(section);

        if (instance) instance.measure();
      }, 60);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
